'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _smoothScroll = require('smooth-scroll');

var _smoothScroll2 = _interopRequireDefault(_smoothScroll);

var _throttle2 = require('lodash/throttle');

var _throttle3 = _interopRequireDefault(_throttle2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbStripInpageNavigatieV1.$inject = ['$window', '$timeout'];


var _ = { throttle: _throttle3.default };

var _module = angular.module('cb.strips.cbStripInpageNavigatieV1', []);

_module.directive('cbStripInpageNavigatieV1', cbStripInpageNavigatieV1);

exports.default = _module;


function cbStripInpageNavigatieV1($window, $timeout) {
    return {
        restrict: 'A',
        link: cbStripInpageNavigatieV1Link
    };

    function cbStripInpageNavigatieV1Link(scope, element, attr) {
        var pillList = $(element).find('.pill-list')[0];

        $(pillList).on('scroll', _.throttle(function () {
            $window.requestAnimationFrame(function () {
                if (pillList.scrollLeft > 0) {
                    $(pillList).removeClass('pill-list--gradient');
                } else {
                    $(pillList).addClass('pill-list--gradient');
                }
            });
        }, 100));
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/strips/inpage-navigatie-v1/inpage-navigatie.directive.js
// module id = 948
// module chunks = 1